<!-- Comments/Approval Card Section - Modified to match screenshot design w/ improved file upload layout -->
 <div   id="print-section" class="bg-slate-100 p-2">

   <div class="flex justify-between items-center border-b-2 border-gray-200 pb-1">
     <h4 class="text-xl font-bold mb-2 flex items-center">
       <i class="pi pi-file-o text-blue-600 text-2xl mr-2"></i> File Management
     </h4>
     <div class="flex gap-3">
       <button   ngxPrint 
             printSectionId="print-section" 
             [useExistingCss]="true"
         class="flex items-center gap-2 px-2 py-1 bg-blue-100 hover:bg-blue-500 hover:text-white text-blue-600 font-semibold rounded shadow">
         <i class="pi pi-print"></i>
       </button>
       <span class="bg-green-500 text-sm text-white font-semibold px-2 py-1 rounded-full flex items-center gap-1">
         <i class="pi pi-check-circle"></i> Approve
       </span>
     </div>
   </div>
   
   
   
   <div class="max-w-full mx-auto  bg-slate-50 min-h-screen font-sans antialiased text-slate-900  "  
     [ngClass]="{'p-4 sm:p-6': !currentObject?.isCommentSectionExpend}"
   >
   
     <!-- MAIN WRAPPER -->
     <div class="relative">
   
       <!-- LEFT SIDE: ACTIVITIES LIST -->
       <div class="relative">
         <div class="absolute left-4 top-0 bottom-0 w-[2px] bg-slate-300"></div>
   
         <div *ngFor="let item of commentData; let i = index" class="relative pl-10 mb-8">
           
           <!-- Timeline dot -->
           <div *ngIf="!currentObject?.isCommentSectionExpend" class="absolute left-[10px] top-3 z-20">
             <div class="w-3.5 h-3.5 rounded-full bg-white border-2 border-indigo-500 ring-2 ring-slate-50"></div>
           </div>
   
           <!-- Activity card -->
           <div class="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden flex flex-col transition-all hover:shadow-lg">
     
             <div class="px-4 py-2 bg-slate-50/80 border-b border-slate-100 flex items-center justify-between gap-3">
               <div class="flex items-center gap-3">
                 <span class="px-2 py-0.5 bg-indigo-50 text-indigo-600 text-[10px] font-bold uppercase tracking-tight rounded-md border border-indigo-100/50">
                   {{ item?.comment?.length > 0 ? "Commented" : "In Progress" }}
                 </span>
                 <div class="flex items-center text-[11px] text-slate-500 font-medium">
                   <span *ngIf="item?.assigned_by?.unit" class="hover:text-indigo-600 transition-colors cursor-default">
                     {{item?.assigned_by?.unit}}
                   </span>
                   <i class="pi pi-angle-right mx-1.5 text-[10px] text-slate-300"></i>
                   <span *ngIf="item?.unit?.name" class="text-slate-700 font-semibold">
                     {{item?.unit?.name}}
                   </span>
                 </div>
               </div>

               
               <div class="flex items-center gap-3">
                 <button *ngIf="currentUserRoleCode === 'DADMIN' && item?.comment?.length === 0 && currentUnitId == item?.unit?.id"
                   class="text-[10px] font-black text-white bg-indigo-500 hover:bg-indigo-600 transition-colors uppercase tracking-widest px-2 py-0.5 rounded shadow-sm mr-1 flex items-center gap-1 h-6"
                   type="button"
                   (click)="openCommentBox(2,item)"
                 >
                   <i class="fas fa-plus mr-0.5"></i>
                   Coord comment
                 </button>
                 <div class="flex flex-col items-end">
                   <span class="text-[10px] font-semibold text-slate-500 tabular-nums">
                     {{ item?.assigned_time | date:'MMM d, yyyy' }}
                   </span>
                   <span class="text-[9px] text-slate-400 font-medium uppercase tracking-tighter -mt-1">
                     {{ item?.assigned_time | date:'h:mm a' }}
                   </span>
                 </div>
                 <button 
                   *ngIf="item?.unit?.id == currentUnitId && item?.children?.length > 0"  
                   (click)="openInternalComment(item)" 
                   class="group flex items-center gap-2 px-3 py-1 h-8 rounded-lg bg-gradient-to-r from-indigo-50 via-white to-slate-50 border border-indigo-100 shadow-sm hover:from-indigo-100 hover:to-blue-50 hover:border-indigo-300 transition-all duration-200"
                 >
                   <span class="w-6 h-6 flex items-center justify-center rounded-full bg-indigo-100 group-hover:bg-indigo-500 text-indigo-500 group-hover:text-white transition-colors">
                     <i class="fas fa-comments text-xs"></i>
                   </span>
                   <span class="text-xs font-semibold text-indigo-600 group-hover:text-indigo-700 tracking-tight transition-colors">
                     Internal Comments
                   </span>
                   <i class="fas fa-chevron-right text-[10px]"></i>
                 </button>
               </div>
             </div>
           
             <div *ngIf="item?.remarks" class="px-5 py-2 bg-amber-50/30 border-b border-amber-100/50 flex items-center gap-2">
               <div class="flex-none w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></div>
               <span class="text-[10px] font-bold text-amber-700 uppercase tracking-wider">Regarding:</span>
               <span  class="text-[11px] font-medium text-slate-600 truncate italic">
                 "{{ item.remarks || 'Nil Comment' }}"
               </span>
             </div>
   
             <div *ngIf="item?.comment.length > 0" class="px-5 py-4 text-left">
               <p class="text-[13px] text-start text-slate-700 leading-relaxed font-medium">
                 <span [innerHTML]="item?.comment[0].content"></span>
               </p>
           
               <div *ngIf="item?.comment[0].files" class="flex flex-wrap flex-row-reverse gap-2 mt-4">
                 <a *ngFor="let tag of item?.comment[0].files"
                    [href]="baseUrl + tag.file || '#'"
                    target="_blank"
                    rel="noopener"
                    class="flex items-center gap-2 px-2 py-1 bg-slate-50 border border-slate-100 rounded text-[10px] font-bold text-slate-500 hover:text-indigo-600 transition-colors cursor-pointer">
                   {{ getFileNmae(tag.file) }}
                   <i class="fas fa-paperclip text-[9px]"></i>
                 </a>
               </div>
             </div>
           
             <div *ngIf="item?.comment?.length === 0" 
                  class="flex flex-col items-center justify-center py-10 px-6 bg-white transition-all">
               <div *ngIf="!currentObject?.isCommentSectionExpend" class="relative mb-3">
                 <div class="absolute inset-0 bg-indigo-100 rounded-full scale-150 blur-xl opacity-40"></div>
                 <i class="fas fa-hourglass-half text-indigo-400 text-xl relative z-10 animate-spin-slow"></i>
               </div>
               <h5 class="text-[13px] font-bold text-slate-700">Internal processing...</h5>
               <p class="text-[11px] text-slate-400 font-medium text-center">The comment is being drafted internally.</p>
             </div>
           
             <div class="px-5 py-3 bg-slate-50/80 border-t border-slate-200 flex items-center justify-between mt-auto">
     
               <div class="flex items-center gap-3">
                 <div [class]="getNumberColor(item?.id)" 
                      class="w-9 h-9 rounded-lg flex items-center justify-center text-white font-black text-xs shadow-sm border-2 border-white ring-1 ring-slate-200">
                   {{ item?.unit?.name?.charAt(0) }}
                 </div>
                 <div>
                   <p class="text-[11px] font-black text-slate-800 uppercase tracking-tight leading-none mb-1">
                     {{ item?.unit?.name }}
                   </p>
                   <div class="flex items-center gap-1.5">
                     <span class="flex h-1.5 w-1.5 rounded-full bg-indigo-500 animate-pulse"></span>
                     <span class="text-[9px] text-indigo-600 font-black uppercase tracking-widest">External Review</span>
                   </div>
                 </div>
               </div>
             
               <div class="flex items-center gap-4">
                 
                 <div *ngIf="item?.comment.length > 0" 
                      class="flex items-center gap-3 bg-white border border-slate-200 p-1.5 pr-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                   
                   <div class="relative group">
                     <div class="bg-slate-50 rounded border border-slate-100 p-1 flex items-center justify-center">
                       <qrcode
                         [qrdata]="getQrPayload(item?.comment[0]?.user)"
                         [width]="44"
                         [errorCorrectionLevel]="'M'"
                         [margin]="0"
                       ></qrcode>
                     </div>
                     <span class="absolute -bottom-1 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[6px] px-1 rounded-full font-bold uppercase whitespace-nowrap">Scan to Verify</span>
                   </div>
             
                   <div class="flex flex-col border-l border-slate-100 pl-3">
                     <p class="text-[8px] font-black text-indigo-500 uppercase tracking-tighter leading-none mb-1">Digitally Signed By</p>
                     <p class="text-[11px] font-bold text-slate-900 leading-tight">
                       {{item?.comment[0]?.user?.rankCode}} {{item?.comment[0]?.user?.first_name}} {{item?.comment[0]?.user?.last_name}}
                     </p>
                     <div class="flex flex-col mt-0.5 space-y-0.5">
                       <p class="text-[9px] text-slate-500 leading-none">
                         <span class="font-bold text-slate-400">DSG:</span> {{item?.comment[0]?.user?.hrcdf_designation}}
                       </p>
                       <p class="text-[9px] text-slate-500 leading-none">
                         <span class="font-bold text-slate-400">DIR:</span> {{item?.comment[0]?.user?.unit}}
                       </p>
                     </div>
                   </div>
                 </div>
             
                 <div class="flex flex-col items-end border-l border-slate-200 pl-4 py-1">
                   <div class="flex items-center gap-1 px-2 py-0.5 bg-emerald-50 border border-emerald-100 rounded-full">
                     <i class="fas fa-certificate text-emerald-500 text-[8px]"></i>
                     <span class="text-[8px] font-black text-emerald-700 uppercase tracking-widest leading-none">Verified</span>
                   </div>
                   <p class="text-[7px] text-slate-400 font-bold uppercase tracking-tighter mt-1.5">Global-CA Security</p>
                   <p class="text-[6px] text-slate-300 font-medium leading-none">ID: #{{item?.id?.toString().slice(-6)}}</p>
                 </div>
             
               </div>
             </div>
           
             <!-- <div class="px-5 py-2.5 border-t border-slate-50 flex items-center gap-6 bg-slate-50/50">
               <button class="flex items-center gap-1.5 text-[9px] font-bold text-slate-400 hover:text-indigo-600 uppercase tracking-widest transition-all">
                 <i class="fas fa-reply text-[10px]"></i> Reply
               </button>
               <button (click)="openCommentBox(3)" class="flex items-center gap-1.5 text-[9px] font-bold text-slate-400 hover:text-amber-600 uppercase tracking-widest transition-all">
                 <i class="fas fa-edit text-[10px]"></i> Edit
               </button>
               <button class="flex items-center gap-1.5 text-[9px] font-bold text-slate-300 hover:text-red-500 uppercase tracking-widest transition-all ml-auto">
                 <i class="fas fa-trash text-[10px]"></i> Delete
               </button>
             </div> -->
           </div>
   
           <!-- Replies -->
           <div *ngIf="item.replies?.length" class="mt-3 space-y-3 ml-2">
             <div class="absolute left-[-21px] top-[-10px] bottom-6 w-5 border-l border-b border-slate-200 rounded-bl-xl"></div>
             
             <div *ngFor="let reply of item?.replies" class="relative pl-4">
               <div class="bg-white border border-slate-100 rounded-lg p-3 shadow-sm">
                  <div class="flex items-center gap-2 mb-2">
                     <div [class]="reply.user.color" 
                          class="w-5 h-5 rounded-full flex items-center justify-center text-[8px] text-white font-black">
                       {{ reply.user.initial }}
                     </div>
                     <span class="text-[10px] font-black text-slate-700">
                       {{ reply.user.name }}
                     </span>
                     <span class="text-[8px] text-slate-300 uppercase">
                       {{ reply.time }}
                     </span>
                  </div>
                  <p class="text-xs text-slate-500 leading-tight border-l border-indigo-100 pl-3">
                    "{{ reply.content }}"
                  </p>
               </div>
             </div>
           </div>
   
         </div>
       </div>
   
       <!-- RIGHT SIDE: SLIDE-IN COMMENT / TIMELINE PANEL -->
       <div class="absolute inset-0 flex justify-end overflow-hidden pointer-events-none min-h-screen">
         <div
           class="w-full  h-full bg-slate-50 shadow-xl border-l border-slate-200
                  transition-transform transition-opacity duration-300 transform"
           [ngClass]="currentObject?.isCommentSectionExpend
             ? 'translate-x-0 opacity-100 pointer-events-auto'
             : 'translate-x-full opacity-0'"
         >
   
           <!-- Top bar -->
           <div class="flex items-center justify-between px-4 py-3 border-b bg-white">
             <h3 class="text-xs font-black tracking-widest text-slate-600 uppercase">
               Internal Comments - {{ currentObject?.unit?.name }}
             </h3>
             <div class="flex items-center gap-2" *ngIf="!type">
               <button *ngIf="currentUserRoleCode === 'DADMIN' && currentObject?.comment?.length === 0"
                 class="text-[10px] font-black text-white bg-indigo-500 hover:bg-indigo-600 transition-colors uppercase tracking-widest px-3 py-1 rounded shadow-sm mr-2 flex items-center gap-1"
                 type="button"
                 (click)="openCommentBox(2,currentObject)"
               >
                 <i class="fas fa-plus mr-1"></i> Consolidate Comment
               </button>
               <button (click)="closeInternalComment()"
                       class="text-[10px] font-black text-slate-400 hover:text-red-500 uppercase tracking-widest">
                 <i class="fas fa-times mr-1"></i> Close
               </button>
             </div>
           </div>
   
           <!-- Timeline / details -->
           <div class="flex flex-col relative p-6 sm:p-8 overflow-y-auto h-[calc(100%-48px)]">
             <div *ngFor="let event of currentObject?.children || []; let i = index; let isLast = last" 
                  class="flex flex-row-reverse gap-x-4 relative group ">
   
               <div class="relative flex flex-col items-center w-10 flex-shrink-0">
                 <div *ngIf="!isLast"
                      class="absolute top-4 bottom-0 w-[2px] pointer-events-none"
                      [ngClass]="{
                        'bg-emerald-400': event.activities.length > 0,   
                        'bg-yellow-400': event.activities.length === 0    
                      }"
                      [attr.data-id]="event.id"
                      [attr.data-comments]="event.activities.length">
                 </div>
                 
                 <div class="relative z-10 w-10 h-10 rounded-full flex items-center justify-center shadow-sm border-[3px] transition-all duration-300 group-hover:scale-110"
                      [ngClass]="event.activities.length > 0
                        ? 'bg-emerald-100 border-emerald-500 text-emerald-600'
                        : 'bg-yellow-100 border-yellow-500 text-yellow-600 animate-pulse'">
                   <i [ngClass]="event.activities.length > 0 ? 'fas fa-check' : 'fas fa-hourglass-half fa-spin text-sm'"></i>
                 </div>
               </div>
   
               <div class="flex-1 pb-2 pr-2 mb-6">
                 <div class="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden flex flex-col transition-all hover:shadow-lg">
     
                   <div class="px-4 py-2 bg-slate-50/80 border-b border-slate-100 flex items-center justify-between gap-3">
                     
                     <div class="flex items-center gap-3">
                       <span class="px-2 py-0.5 bg-indigo-50 text-indigo-600 text-[10px] font-bold uppercase tracking-tight rounded-md border border-indigo-100/50">
                         {{ event.activities.length > 0 ? 'Completed' : 'Upcoming' }}
                       </span>
                       
                       <div class="flex items-center text-[11px] text-slate-500 font-medium">
                         <span *ngIf="event?.assigned_by?.unit" class="hover:text-indigo-600 transition-colors cursor-default">
                           {{event?.assigned_by?.unit}}
                         </span>
                         <i class="pi pi-angle-right mx-1.5 text-[10px] text-slate-300"></i>
                         <span *ngIf="event?.user?.loginname" class="text-slate-700 font-semibold">
                           {{event?.user?.loginname}}
                         </span>
                       </div>
                     </div>
                 
                     <div class="flex items-center gap-3">
                       <div class="flex flex-col items-end">
                         <span class="text-[10px] font-semibold text-slate-400 tabular-nums">
                           {{ event?.assigned_time | date:'MMM d, yyyy' }}
                         </span>
                         <span class="text-[9px] text-slate-300 font-medium uppercase tracking-tighter -mt-1">
                           {{ event?.assigned_time | date:'h:mm a' }}
                         </span>
                       </div>
                 
                       <button *ngIf="(stepDetails.can_comment || event?.can_comment && type ) && event.user.id == currentUserId && event.activities.length == 0"    (click)="openCommentBox(0,event)" 
                               type="button"
                               class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white text-[10px] font-bold shadow-sm shadow-emerald-100 transition-all active:scale-95 group">
                         <i class="fas fa-comment-medical group-hover:rotate-12 transition-transform"></i>
                         <span>Add Comment</span>
                       </button>
                     </div>
                   </div>
                 
                   <div *ngIf="event?.remarks"class="px-5 py-2 bg-amber-50/30 border-b border-amber-100/50 flex items-center gap-2">
                     <div class="flex-none w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></div>
                     <span class="text-[10px] font-bold text-amber-700 uppercase tracking-wider">Regarding:</span>
                     <span  class="text-[11px] font-medium text-slate-600 truncate italic">
                       "{{ event.remarks || 'Internal Process' }}"
                     </span>
                   </div>
                   <div *ngIf="event.activities.length > 0" class="px-5 py-4 text-right">
                     <p class="text-[13px] text-start text-slate-700 leading-relaxed font-medium">
                       <span [innerHTML]="event.activities[0].content"></span>
                     </p>
                 
                     <div *ngIf="event.activities[0].files" class="flex flex-wrap flex-row-reverse gap-2 mt-4">
                       <a *ngFor="let tag of event.activities[0].files"
                          [href]="baseUrl + tag.file || '#'"
                          target="_blank"
                          rel="noopener"
                          class="flex items-center gap-2 px-2 py-1 bg-slate-50 border border-slate-100 rounded text-[10px] font-bold text-slate-500 hover:text-indigo-600 transition-colors cursor-pointer">
                         {{ getFileNmae(tag.file) }}
                         <i class="fas fa-paperclip text-[9px]"></i>
                       </a>
                     </div>
                   </div>
                 
                   <div *ngIf="event.activities.length === 0" 
                        class="flex flex-col items-center justify-center py-10 bg-white">
                     <div class="relative mb-3">
                       <div class="absolute inset-0 bg-indigo-100 rounded-full scale-150 blur-xl opacity-40"></div>
                       <i class="fas fa-hourglass-half text-indigo-400 text-xl relative z-10 animate-pulse"></i>
                     </div>
                     <h5 class="text-[12px] font-bold text-slate-700 uppercase tracking-widest">Coming Soon</h5>
                     <p class="text-[11px] text-slate-400 mt-1">Notification sent; comment is being processed.</p>
                   </div>
                 
                   <div class="px-5 py-3 bg-slate-50/50 border-t border-slate-100 flex items-center justify-between">
                     
                     <!-- <div class="flex items-center gap-4">
                       <button (click)="openCommentBox(1)" 
                               class="flex items-center gap-1.5 text-[9px] font-bold text-slate-400 hover:text-amber-600 uppercase tracking-widest transition-all">
                         <i class="fas fa-edit"></i> Edit
                       </button>
                       <button class="flex items-center gap-1.5 text-[9px] font-bold text-slate-300 hover:text-red-500 uppercase tracking-widest transition-all">
                         <i class="fas fa-trash"></i> Delete
                       </button>
                     </div> -->
                 
                     <div class="flex flex-row items-stretch border-l border-slate-200 pl-4 gap-4">
                       <div *ngIf="event.activities.length > 0" class="flex flex-row items-center gap-3 bg-blue-50 rounded-lg border border-blue-200 px-2 py-1 shadow-sm min-w-[290px]">
                         <div class="bg-white rounded-lg border border-blue-200 flex items-center justify-center min-w-[60px] min-h-[60px] p-1">
                           <qrcode
                             [qrdata]="getQrPayload(event.activities[0]?.user)"
                             [width]="50"
                             [errorCorrectionLevel]="'M'"
                           ></qrcode>
                         </div>
                         <div class="flex flex-col justify-center pl-2">
                           <p class="text-[13px] font-semibold text-slate-700 mb-1 leading-snug">
                             Electronically Signed by:
                           </p>
                           <p class="text-[12px] font-medium text-slate-700 mb-1 whitespace-nowrap">
                             {{event.activities[0]?.user?.rankCode}} {{event.activities[0]?.user?.first_name}} {{event.activities[0]?.user?.last_name}}
                           </p>
                           <p class="text-[11px] text-slate-600">
                             <span class="font-semibold">Designation:</span> {{event.activities[0]?.user?.hrcdf_designation}}
                           </p>
                           <p class="text-[11px] text-slate-600">
                             <span class="font-semibold">Directorate:</span> {{event.activities[0]?.user?.unit}}
                           </p>
                         </div>
                       </div>
                       <div class="flex flex-col justify-center items-start flex-1 min-w-[110px]">
                         <p class="text-[8px] font-black text-emerald-600 uppercase tracking-widest leading-none flex items-center gap-1">
                           <i class="fas fa-shield-alt"></i> System Verified
                         </p>
                         <p class="text-[7px] text-slate-400 font-medium mt-0.5 uppercase tracking-tighter text-right">
                           Internal Communication Channel
                         </p>
                       </div>
                     </div>
                   </div>
                 
                 </div>
               </div>
       
             </div>
           </div>
   
         </div>
       </div>
   
     </div>
   </div>
 </div>




<!-- pdolog start -->
<p-dialog
  [header]="getHeader()"
  [(visible)]="showPDODialog"
  [modal]="true"
  [style]="{width: '60vw'}"
  [contentStyle]="{'padding':'0', 'overflow':'visible'}"
  [dismissableMask]="true"
>
  <ng-template pTemplate="content">
    <div  class="mb-2 bg-amber-50 p-2 border rounded flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <label class="text-xs font-semibold text-slate-700">Files</label>
        <input type="file" multiple
          class="text-xs text-slate-700 border border-slate-300 rounded px-1.5 py-0.5 h-7 file:mr-2 file:py-0.5 file:px-2 file:rounded file:border-0 file:text-xs file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          style="max-width: 170px;" (change)="onFilesSelected($event)" />
       
      </div>
      <div class="flex flex-col gap-1">
        <label class="text-xs font-semibold text-slate-700">Comment</label>
        <editor [(ngModel)]="comment" [init]="init"></editor>
      </div>
    </div>
    <div class="flex justify-end m-3">
      <button class="px-2 py-1 bg-blue-500 text-white rounded flex items-center gap-1 shadow text-xs h-7"
      (click)="submitComment()">
      <i class="pi pi-send"></i> Submit
    </button>
    </div>
  </ng-template>
</p-dialog>



